module.exports = __webpack_public_path__ + "static/media/bolso (26).eddefbaa.jpg";